@let corporateDesign = corporateDesignService.corporateDesign();
<div [formGroup]="productForm()" class="flex flex-col gap-4">
  @for (
    attribute of productForm().controls.selectionAttributes.controls;
    track attribute
  ) {
    <div class="flex w-full flex-row flex-wrap gap-1">
      <span
        class="mb-1"
        [attr.data-testid]="'ticket-name'"
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_text_high
            : '',
        }"
        >{{ selectionAttributes()[$index].name }}</span
      >
      <aw-button-group
        [id]="'attribute-' + $index"
        [style]="'primary'"
        [buttonsPerRow]="3"
        [formControl]="attribute"
        (valueChange)="pickProductFromForm()"
        [options]="
          selectionAttributes()[$index].values | stringArraytoButtonOptionArray
        "></aw-button-group>
    </div>
  }
  @for (
    productSortOption of productForm().controls.productSortOptions.controls;
    track productSortOption
  ) {
    <div class="flex w-full flex-row flex-wrap gap-1">
      <span
        class="mb-1"
        [attr.data-testid]="'ticket-sort-name'"
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_text_high
            : '',
        }"
        >{{ productSortOptions()[$index].name }}</span
      >
      <aw-button-group
        [id]="'product-sort-option-' + $index"
        [style]="'primary'"
        [buttonsPerRow]="3"
        [formControl]="productSortOption"
        (valueChange)="pickProductFromForm()"
        [options]="
          productSortOptions()[$index].values | stringArraytoButtonOptionArray
        "></aw-button-group>
    </div>
  }
  @if (productForm().controls.product.value) {
    <aw-date-input
      id="ticket-configuration-date"
      [label]="
        textStore.texts()
          | filterTexts
            : ERelationType.travelData
            : EEntityType.ticketConfiguration
          | language
      "
      formControlName="travelDate"
      [darkModeLabelColor]="corporateDesign.colorAdmixtures.dark_text_disabled"
      [restrictedDateList]="listDatesToDate(listDates())"
      [showTimePicker]="showTimePicker()">
      {{
        textStore.texts()
          | filterTexts: dateInputErrorRelationType() : EEntityType.generalArea
          | language
      }}
    </aw-date-input>

    @if (isGroupTicket()) {
      <span
        [attr.data-testid]="'ticket-person-count'"
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_text_high
            : '',
        }"
        >{{
          textStore.texts()
            | filterTexts
              : ERelationType.numberOfPeople
              : EEntityType.directTicket
            | language
        }}</span
      >
      <div class="flex flex-row gap-2">
        <aw-button
          id="ticket-configuration-amount-of-people-subtract"
          [style]="'primary'"
          [type]="'button'"
          [disabledText]="
            textStore.texts()
              | filterTexts
                : ERelationType.ticketAmountDecreaseDisabled
                : EEntityType.directTicket
              | language
          "
          [isDisabled]="
            productForm().controls.amountOfPeople.value <=
            (productForm().controls.product.value?.minNumberOfPeople ??
              productForm().controls.product.value?.numberOfPeople ??
              1)
          "
          (click)="changeAmountOfPeople(productForm(), -1)">
          <span class="material-symbols-rounded"> remove </span>
        </aw-button>
        <aw-static-form-field
          class="max-w-52"
          id="ticket-configuration-amount-of-people"
          [label]="
            textStore.texts()
              | filterTexts: ERelationType.amount : EEntityType.generic
              | language
          "
          formControlName="amountOfPeople"></aw-static-form-field>
        <aw-button
          id="ticket-configuration-amount-of-people-add"
          [style]="'primary'"
          [type]="'button'"
          [disabledText]="
            textStore.texts()
              | filterTexts
                : ERelationType.ticketAmountIncreaseDisabled
                : EEntityType.directTicket
              | language
          "
          [isDisabled]="
            productForm().controls.amountOfPeople.value >=
            (productForm().controls.product.value?.maxNumberOfPeople ??
              productForm().controls.amountOfPeople.value)
          "
          (click)="changeAmountOfPeople(productForm(), 1)">
          <span class="material-symbols-rounded"> add </span>
        </aw-button>
      </div>
    }

    <span
      [attr.data-testid]="'ticket-amount'"
      [ngStyle]="{
        color: corporateDesignService.isDarkModeActive()
          ? corporateDesign.colorAdmixtures.dark_text_high
          : '',
      }"
      >{{
        textStore.texts()
          | filterTexts: ERelationType.ticketAmount : EEntityType.directTicket
          | language
      }}</span
    >
    <div class="flex flex-row gap-2">
      <aw-button
        id="ticket-configuration-amount-subtract"
        [style]="'primary'"
        [type]="'button'"
        [disabledText]="
          textStore.texts()
            | filterTexts
              : ERelationType.ticketAmountDecreaseDisabled
              : EEntityType.directTicket
            | language
        "
        [isDisabled]="
          productForm().controls.amount.value <= shoppingCartService.minAmount
        "
        (click)="decreaseAmount(productForm())">
        <span class="material-symbols-rounded"> remove </span>
      </aw-button>
      <aw-static-form-field
        class="max-w-52"
        id="ticket-configuration-amount"
        [label]="
          textStore.texts()
            | filterTexts: ERelationType.amount : EEntityType.generic
            | language
        "
        formControlName="amount"></aw-static-form-field>
      <aw-button
        id="ticket-configuration-amount-add"
        [style]="'primary'"
        [type]="'button'"
        [disabledText]="
          textStore.texts()
            | filterTexts
              : ERelationType.ticketAmountIncreaseDisabled
              : EEntityType.directTicket
            | language
        "
        [isDisabled]="
          productForm().controls.amount.value >= shoppingCartService.maxAmount
        "
        (click)="increaseAmount(productForm())">
        <span class="material-symbols-rounded"> add </span>
      </aw-button>
    </div>
    <aw-additional-entries-form
      [entries]="this.getAdditionalEntries()"
      [controls]="
        productForm().controls.additionalEntries
      "></aw-additional-entries-form>
  }
</div>
